/**
 * In some rare case, the only `reportAggregation` option is changed in the new schema(for example, `SearchCampaignChangeHistoryReport`,
 * which is changed from `Daily`(old) to `Summary`(new)), however, we still use it in some situation(like date-range-inline-editor)
 *
 * This means we have to transfrom data immediately when get it to avoid any possiable errors.
 *
 * @param {any} oldTaskItem old back-end data model
 * @returns {any} new back-end data model
 */
export function transformReportAggregationItself(oldTaskItem) {
  // handle the ReportType explictly rather than by some rules, to make it more easier to understand

  // manually compare package '@bingads-webui/report-ui-interface-preview' and '@bingads-webui/report-ui-interface'
  // to get the result
  const newTaskItem = { ...oldTaskItem };
  if (oldTaskItem.ReportType === 'BudgetSummaryReport'
    || oldTaskItem.ReportType === 'SearchCampaignChangeHistoryReport'
    || oldTaskItem.ReportType === 'UserRoleChangeHistoryReport') {
    newTaskItem.ReportAggregation = 'Summary';
  }
  return newTaskItem;
}
